import { AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents } from "@denishussar/html5-game-engine";
import { Rectangle, Sprite, Texture } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { UIEvents } from "../../Constants/Events";
import { GameModel } from "../../Models/GameModel";
import { ISettingsOptions } from "./Settings";

export interface ISettingsButtonOptions {

}

export class SettingsButtonController extends AnimationBaseController {
    $model: GameModel;

    constructor(
        @Inject private options: ISettingsOptions,
        @Inject private modelEvents: ModelEvents,
    ) {
        super("SettingsButtonController");
    }

    getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.SETTINGS_JSON,
            libraryName: "settingsButton",
            childControllers: {
                button: {
                    instanceName: "btn_settings",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.modelEvents.dispatch(this.$model, UIEvents.showSettings, true);
                        }
                    }
                }
            }
        }
    }

    onInitialize() {
        this.getDisplayObjectByQuery("btn_settings")[0].hitArea = new Rectangle(-100, -100, 200, 200);
        // const child = new Sprite(Texture.WHITE);
        // child.width = 200;
        // child.height = 200;
        // child.anchor.set(0.5,0.5);
        // this.display.addChild(child)
    }

    onResize(width, height, scale) {
        const sc = Math.min(
            width / scale / this.$model.gameWidth,
            height / scale / this.$model.gameHeight,
        );
        this.x = (1030 - 540);
        this.y = (-897);
    }
}